import { createBrowserRouter, createHashRouter } from 'react-router-dom'

import Routes from './components/Routes'

let router
/**
 * This variable is defined in vite.config.ts and vite-env-d.ts and it is required to be able
 * to change the url from '/ReactApp' to '/ui' for all the environments but development.
 * Then we have a rule in Azure that redirects the '/ui' route to the files in '/ReactApp'
 */
if (window.location.pathname.startsWith(__STANDALONE_REACT_APP_PATH__)) {
  router = createBrowserRouter(Routes, {
    basename: __STANDALONE_REACT_APP_PATH__,
  })
} else {
  router = createHashRouter(Routes, {
    basename: '/',
  })
}

export default router
